/* ============================================================================
   mt-lanzamiento.js — "Notifícame cuando salga" (contador de la portada)
   ----------------------------------------------------------------------------
   El botón de la cinta abre una ventana (<dialog>) donde la clienta deja su
   correo —o su WhatsApp, cuando esté habilitado— para que le avisemos una sola
   vez, el día que la colección sale.

   Qué canales se ofrecen lo decide la sección (data-canales): mientras Meta no
   apruebe la plantilla, el bot no puede mandar WhatsApp, así que se ofrece solo
   correo. Prometer un canal que no podemos cumplir es peor que no ofrecerlo.

   SOLO CHILE (WhatsApp): aquí solo se acepta un móvil chileno de 9 dígitos que
   parte en 9, y siempre se envía normalizado como 56XXXXXXXXX. El servidor lo
   vuelve a comprobar: este candado es comodidad, no seguridad.

   Quien ya se anotó desde este navegador ve el botón como "Ya estás anotada":
   evita la duda de "¿quedé o no quedé?" sin tener que preguntarle al servidor.
   ============================================================================ */
(function () {
  'use strict';

  var ENDPOINT = 'https://whatsbot-kappa.vercel.app/lanzamiento/registrar';
  var GUARDADAS = 'mt_lanzamiento_anotadas';

  function anotadas() {
    try { return JSON.parse(localStorage.getItem(GUARDADAS) || '[]'); } catch (e) { return []; }
  }
  function recordar(campana) {
    try {
      var l = anotadas();
      if (l.indexOf(campana) === -1) { l.push(campana); localStorage.setItem(GUARDADAS, JSON.stringify(l)); }
    } catch (e) { /* navegación privada: se pierde el recuerdo, nada más */ }
  }

  // "9 5678 1234" / "+56 9 5678 1234" / "956781234" → "56956781234", o null.
  function movilChileno(v) {
    var d = String(v || '').replace(/\D/g, '');
    if (d.indexOf('56') === 0) d = d.slice(2);
    if (d.indexOf('0') === 0) d = d.slice(1);
    return /^9\d{8}$/.test(d) ? '56' + d : null;
  }

  // Filtro de cortesía: el servidor hace la validación de verdad (y sugiere
  // correcciones tipo "gmial.com"). Aquí solo se atajan los errores obvios para
  // no hacer ir y volver al servidor por una falta evidente.
  function pareceCorreo(v) {
    return /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(String(v || '').trim());
  }

  function iniciar(vent) {
    if (vent.dataset.mtListo === '1') return;
    vent.dataset.mtListo = '1';

    var campana = vent.dataset.campana || '';
    var canales = (vent.dataset.canales || 'email').split(',');
    var soloCorreo = canales.indexOf('whatsapp') === -1;

    var q = function (sel) { return vent.querySelector(sel); };
    var pasoDatos = q('[data-paso="datos"]');
    var pasoExito = q('[data-paso="exito"]');
    var campoTel = q('[data-campo="whatsapp"]');
    var campoMail = q('[data-campo="email"]');
    var inputTel = q('[data-tel]');
    var inputMail = q('[data-mail]');
    var error = q('[data-error]');
    var enviar = q('[data-enviar]');
    var sub = q('[data-sub]');
    var canalExito = q('[data-canal-exito]');

    var canal = soloCorreo ? 'email' : 'whatsapp';

    function pinta() {
      var esMail = canal === 'email';
      if (campoTel) campoTel.hidden = esMail;
      if (campoMail) campoMail.hidden = !esMail;
      if (sub) sub.textContent = esMail
        ? 'Déjanos tu correo y te avisamos apenas salga.'
        : 'Déjanos tu WhatsApp y te avisamos apenas salga.';
      if (enviar) enviar.textContent = esMail ? 'Avísame por correo' : 'Avísame por WhatsApp';
      vent.querySelectorAll('[data-canal]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.dataset.canal === canal));
      });
      muestraError('');
    }

    function muestraError(msg) {
      if (!error) return;
      error.textContent = msg || '';
      error.hidden = !msg;
    }

    vent.querySelectorAll('[data-canal]').forEach(function (b) {
      b.addEventListener('click', function () {
        canal = b.dataset.canal;
        pinta();
        var foco = canal === 'email' ? inputMail : inputTel;
        if (foco) foco.focus();
      });
    });

    vent.querySelectorAll('[data-cerrar]').forEach(function (b) {
      b.addEventListener('click', function () { vent.close(); });
    });

    [inputTel, inputMail].forEach(function (i) {
      if (!i) return;
      i.addEventListener('input', function () { muestraError(''); });
      i.addEventListener('keydown', function (ev) {
        if (ev.key === 'Enter') { ev.preventDefault(); manda(); }
      });
    });

    function manda() {
      if (!enviar || enviar.disabled) return;
      var cuerpo = { campana: campana };
      var legible;

      if (canal === 'email') {
        var correo = (inputMail && inputMail.value || '').trim();
        if (!pareceCorreo(correo)) return muestraError('Revisa tu correo, parece que le falta algo.');
        cuerpo.email = correo;
        legible = correo;
      } else {
        var tel = movilChileno(inputTel && inputTel.value);
        if (!tel) return muestraError('Necesitamos un WhatsApp de Chile: 9 y ocho números más.');
        cuerpo.phone = tel;
        legible = 'WhatsApp';
      }

      enviar.disabled = true;
      var antes = enviar.textContent;
      enviar.textContent = 'Anotando…';

      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(cuerpo)
      })
        .then(function (r) { return r.json().catch(function () { return {}; }); })
        .then(function (d) {
          if (!d || !d.ok) {
            muestraError((d && (d.sugerencia ? d.error + ' ¿Quisiste decir ' + d.sugerencia + '?' : d.error)) ||
              'No pudimos anotarte. Intenta de nuevo en un momento.');
            return;
          }
          recordar(campana);
          if (canalExito) canalExito.textContent = canal === 'email' ? 'por correo' : 'por WhatsApp';
          if (pasoDatos) pasoDatos.hidden = true;
          if (pasoExito) pasoExito.hidden = false;
          marcaBotones();
        })
        .catch(function () {
          muestraError('No pudimos anotarte. Revisa tu conexión e intenta de nuevo.');
        })
        .then(function () {
          enviar.disabled = false;
          enviar.textContent = antes;
        });
    }

    if (enviar) enviar.addEventListener('click', manda);

    // El toggle de canales sobra cuando solo hay uno.
    var grupo = q('[data-canales]');
    if (grupo && soloCorreo) grupo.hidden = true;

    pinta();
    cuenta(vent);
  }

  // El mismo reloj de la cinta, en pequeño, dentro de la ventana: recuerda para
  // qué se está anotando. Si la fecha no sirve, el bloque desaparece en vez de
  // mostrar ceros.
  function cuenta(vent) {
    var caja = vent.querySelector('[data-cuenta]');
    if (!caja) return;
    var objetivo = Date.parse(caja.dataset.objetivo || '');
    if (!objetivo) { caja.hidden = true; return; }

    var dias = caja.querySelector('[data-dias]');
    var horas = caja.querySelector('[data-horas]');
    var minutos = caja.querySelector('[data-minutos]');
    var dos = function (n) { return (n < 10 ? '0' : '') + n; };

    function pinta() {
      var falta = objetivo - Date.now();
      if (falta <= 0) { caja.hidden = true; return; }
      var s = Math.floor(falta / 1000);
      if (dias) dias.textContent = dos(Math.floor(s / 86400));
      if (horas) horas.textContent = dos(Math.floor(s / 3600) % 24);
      if (minutos) minutos.textContent = dos(Math.floor(s / 60) % 60);
    }
    pinta();
    var t = setInterval(pinta, 30000);
    document.addEventListener('shopify:section:unload', function () { clearInterval(t); });
  }

  // El botón de la cinta: abre la ventana, o dice que ya estás anotada.
  function marcaBotones() {
    document.querySelectorAll('[data-mt-hw-avisar]').forEach(function (b) {
      var vent = document.getElementById(b.dataset.ventana || '');
      if (!vent) return;
      if (anotadas().indexOf(vent.dataset.campana || '') !== -1) {
        b.textContent = b.dataset.textoAnotada || 'Ya estás anotada';
        b.classList.add('is-anotada');
      }
    });
  }

  function engancha() {
    document.querySelectorAll('.mt-avisa').forEach(iniciar);
    document.querySelectorAll('[data-mt-hw-avisar]').forEach(function (b) {
      if (b.dataset.mtListo === '1') return;
      b.dataset.mtListo = '1';
      b.addEventListener('click', function () {
        var vent = document.getElementById(b.dataset.ventana || '');
        if (!vent) return;
        if (typeof vent.showModal === 'function') vent.showModal();
        else vent.setAttribute('open', '');
        // El foco a la ventana, no al primer botón: así no se abre con un
        // recuadro alrededor de la ✕ ni salta el teclado del teléfono.
        try { vent.focus({ preventScroll: true }); } catch (e) { /* da igual */ }
      });
    });
    marcaBotones();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', engancha);
  else engancha();
  document.addEventListener('shopify:section:load', engancha);
})();
